import { Link } from "react-router-dom";
import { useState, useEffect } from "react";

const categories = [
  { name: "ORALS ANABOLICS", link: "/athligo/orals", img: "/assets/orals/ax10.jpeg", color: "from-blue-500 to-cyan-500", items: 12 },
  { name: "SUPPLEMENTS", link: "/athligo/suplements", img: "/assets/supplements/eca-burn.jpeg", color: "from-purple-500 to-pink-500", items: 8 },
  { name: "INJECTABLES", link: "/athligo/injectable", img: "/assets/injectables/a.jpeg", color: "from-orange-500 to-red-500", items: 10 },
]

const CategoryGrid = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="py-16 md:py-24 bg-gradient-to-br from-gray-50 via-white to-gray-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header Section with Animation */}
        <div className={`text-center mb-12 md:mb-16 transform transition-all duration-700 ${
          isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
        }`}>
          <span className="inline-block px-4 py-2 rounded-full bg-gradient-to-r from-gray-900 to-gray-700 text-white text-xs font-semibold tracking-wider mb-4 shadow-lg">
            ✦ PREMIUM COLLECTION ✦
          </span>
          
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold">
            <span className="bg-gradient-to-r from-gray-900 to-gray-700 bg-clip-text text-transparent">
              Explore Our 
            </span>
            <br className="sm:hidden" />
            <span className="bg-gradient-to-r from-red-600 to-red-500 bg-clip-text text-transparent">
              {" "}Categories
            </span>
          </h2>
          
          <p className="mt-4 text-gray-600 max-w-2xl mx-auto text-sm sm:text-base">
            Discover our range of premium quality performance products, 
            carefully crafted for your fitness journey
          </p>

          {/* Stats */}
          <div className="flex justify-center gap-6 mt-8">
            <div className="text-center">
              <p className="text-2xl font-bold text-gray-900">{categories.length}</p>
              <p className="text-xs text-gray-500">Categories</p>
            </div>
            <div className="w-px h-10 bg-gray-200"></div>
            <div className="text-center">
              <p className="text-2xl font-bold text-gray-900">42</p>
              <p className="text-xs text-gray-500">Products</p>
            </div>
          </div>
        </div>

        {/* Grid Layout */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7 gap-3 sm:gap-4 lg:gap-6">
          {categories.map((cat, index) => (
            <Link
              key={cat.name}
              to={cat.link}
              className={`group relative transform transition-all duration-500 hover:scale-105 ${
                isVisible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0'
              }`}
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              {/* Card Container */}
              <div className="relative bg-white rounded-2xl sm:rounded-3xl p-4 sm:p-6 shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden">
                
                {/* Gradient Background on Hover */}
                <div className={`absolute inset-0 bg-gradient-to-br ${cat.color} opacity-0 group-hover:opacity-10 transition-opacity duration-300`}></div>
                
                {/* Image Container with 3D Effect */}
                <div className="relative">
                  <div className="absolute inset-0 bg-gradient-to-br from-gray-100 to-gray-200 rounded-full blur-xl group-hover:blur-2xl transition-all duration-300"></div>
                  <div className="relative flex justify-center">
                    <div className="w-20 h-20 sm:w-24 sm:h-24 lg:w-28 lg:h-28 flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100 rounded-full shadow-inner group-hover:shadow-xl transition-all duration-300">
                      <img
                        src={cat.img}
                        alt={cat.name}
                        className="w-12 h-12 sm:w-16 sm:h-16 lg:w-20 lg:h-20 object-contain transform group-hover:scale-110 group-hover:rotate-3 transition-all duration-300 drop-shadow-lg"
                        loading="lazy"
                      />
                    </div>
                  </div>
                </div>

                {/* Category Info */}
                <div className="mt-3 sm:mt-4 text-center">
                  <h3 className="text-xs sm:text-sm lg:text-base font-bold text-gray-800 group-hover:text-transparent group-hover:bg-clip-text group-hover:bg-gradient-to-r group-hover:from-gray-900 group-hover:to-gray-700 transition-all duration-300">
                    {cat.name}
                  </h3>
                  
                  {/* Product Count Badge */}
                  <span className="inline-block mt-1 sm:mt-2 px-2 py-0.5 sm:px-3 sm:py-1 bg-gray-100 rounded-full text-[10px] sm:text-xs text-gray-600 group-hover:bg-gradient-to-r group-hover:from-gray-900 group-hover:to-gray-700 group-hover:text-white transition-all duration-300">
                    {cat.items} items
                  </span>
                </div>

                {/* Quick View Indicator */}
                <div className="absolute top-2 right-2 sm:top-3 sm:right-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-5 h-5 sm:w-6 sm:h-6 bg-white rounded-full shadow-lg flex items-center justify-center">
                    <span className="text-gray-900 text-xs sm:text-sm">→</span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className={`text-center mt-12 md:mt-16 transform transition-all duration-700 delay-700 ${
          isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
        }`}>
          <Link
            to="/shop"
            className="inline-flex items-center gap-2 px-6 sm:px-8 py-3 sm:py-4 bg-gradient-to-r from-gray-900 to-gray-800 text-white text-sm sm:text-base font-semibold rounded-full hover:from-red-600 hover:to-red-500 transition-all duration-300 shadow-lg hover:shadow-xl hover:shadow-red-100 group"
          >
            <span>View All Categories</span>
            <span className="group-hover:translate-x-1 transition-transform">→</span>
          </Link>
        </div>

        {/* Decorative Elements */}
        <div className="hidden lg:block absolute left-0 top-1/4 w-32 h-32 bg-gradient-to-br from-red-100 to-amber-100 rounded-full blur-3xl opacity-30 -z-10"></div>
        <div className="hidden lg:block absolute right-0 bottom-1/4 w-32 h-32 bg-gradient-to-br from-blue-100 to-purple-100 rounded-full blur-3xl opacity-30 -z-10"></div>
      </div>
    </section>
  );
};

export default CategoryGrid;